var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M428.36 25c16.67-16.67 43.76-16.67 60.43 0 16.66 16.67 16.66 43.76 0 60.42L241.71 332.5l247.08 247.08c16.66 16.67 16.66 43.76 0 60.43-16.67 16.66-43.76 16.66-60.43 0-27.71-27.71-249.44-249.37-277.16-277.08a42.325 42.325 0 0 1-12.48-30.34c0-11.11 4.1-22.05 12.48-30.43C206.63 246.73 400.65 52.72 428.36 25Z","fill":"currentColor"}));
}

ChevronLeft.defaultProps = {"viewBox":"0 0 640 640"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
